// Analytics — SPA route tracking via GTM dataLayer only
// GA4 viene gestito server-side dal container Stape sGTM (no gtag.js client-side per evitare doppi page_view)
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function Analytics() {
    const location = useLocation();

    useEffect(() => {
        const path = location.pathname + location.search;
        const title = document.title;

        // GTM — dataLayer event for custom tags (sGTM forwards to GA4)
        if (Array.isArray(window.dataLayer)) {
            window.dataLayer.push({
                event: "page_view",
                page_path: path,
                page_location: window.location.href,
                page_title: title,
            });
        }
    }, [location.pathname, location.search]);

    return null;
}
